import { Selector } from '@ngxs/store';

import { BcStateContext } from '@bayclubs/state';

import { BlockedSlotEventDetailsModel, GroupClassEventDetailsModel, CourtBookingEventDetailsModel } from '@bayclubs/court-booking-employee-api';

import { CourtEventDetailsStateModel } from './court-event-details.state.model';
import { CourtEventDetailsState } from './court-event-details.state';

export class CourtEventDetailsSelectors {
    @Selector([CourtEventDetailsState])
    static blockedSlotDetails(state: CourtEventDetailsStateModel): BcStateContext<BlockedSlotEventDetailsModel> {
        return state.blockedSlotDetails;
    }

    @Selector([CourtEventDetailsState])
    static courtClassDetails(state: CourtEventDetailsStateModel): BcStateContext<GroupClassEventDetailsModel> {
        return state.courtClassDetails;
    }

    @Selector([CourtEventDetailsState])
    static courtBookingDetails(state: CourtEventDetailsStateModel): BcStateContext<CourtBookingEventDetailsModel> {
        return state.courtBookingDetails;
    }
}
